module.exports = __webpack_public_path__ + "static/media/result.a6ca454c.svg";